// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CiscoIntegrationNewLeafIvrRefillOrderResponse } from './ciscoIntegrationNewLeafIvrRefillOrderResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CiscoIntegrationNewLeafRefillOrderValidationResponse {
    'success': boolean;
    'messages': Array<string> | null;
    'data': CiscoIntegrationNewLeafIvrRefillOrderResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CiscoIntegrationNewLeafRefillOrderValidationResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "CiscoIntegrationNewLeafIvrRefillOrderResponse"
        },
    ];

    static getAttributeTypeMap() {
        return CiscoIntegrationNewLeafRefillOrderValidationResponse.attributeTypeMap;
    }
}
